var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{staticClass:"pointer",staticStyle:{"z-index":"10"},attrs:{"type":"is-danger","label":_vm.message},nativeOn:{"click":function($event){return _vm.area.$goToTurnOffTrainingMode({next:_vm.$route.fullPath})}}},[_c('b-icon',{staticClass:"ml-1 mr-1",attrs:{"icon":"exclamation-circle","type":"is-danger"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }